/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const verifyUserAttributePostResponseSchema = z.object({
  data: z.object({}),
  response: z.object({
    date: z.string(),
    messages: z.array(z.string()),
    status: z.number().int(),
    type: z.string(),
  }),
});
